import React, { createContext, useContext, useEffect } from "react";

const CustomerMobileShellContext = createContext(false);

const CUSTOMER_MOBILE_SHELL_BODY_CLASS = "customer-mobile-shell";

export function CustomerMobileShellProvider({ children }) {
  useEffect(() => {
    document.body.classList.add(CUSTOMER_MOBILE_SHELL_BODY_CLASS);
    return () => {
      document.body.classList.remove(CUSTOMER_MOBILE_SHELL_BODY_CLASS);
    };
  }, []);

  return (
    <CustomerMobileShellContext.Provider value={true}>
      {children}
    </CustomerMobileShellContext.Provider>
  );
}

export function useInsideCustomerMobileShellProvider() {
  return useContext(CustomerMobileShellContext);
}

export default CustomerMobileShellContext;
